import { getTeamColor, TEAM_COLORS } from '@ordo/constants/team-colors'
import * as React from 'react'

import { cn } from '../cn'

export { getTeamColor } from '@ordo/constants/team-colors'

/** Canonical Multipass families. Legacy lowercase keys remain readable. */
export const TEAM_COLOR_KEYS = TEAM_COLORS.map((color) => color.name)

export interface TeamCircleProps extends React.HTMLAttributes<HTMLSpanElement> {
  colorKey: string
  size?: 'sm' | 'md'
}

export function TeamCircle({ colorKey, size = 'md', className, style, ...props }: TeamCircleProps) {
  const sizeCls = size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'
  return (
    <span
      aria-hidden
      className={cn(sizeCls, 'shrink-0 rounded-full', className)}
      style={{ backgroundColor: getTeamColor(colorKey).primary, ...style }}
      {...props}
    />
  )
}
